<div class="currency-container">
  <div class="back-button">
    <span class="back-icon icon-arrow-left" (click)="backToMenuClick()"></span>
    <span class="title">Currency</span>
  </div>

  @for (item of currencyList; track item) {
    <div class="currency-option" (click)="changeCurrency(item)" [class.active]="selectedCurrency()?.id === item.id">
      <div class="option-item">
        @if (item?.logo) {
          <img class="icon" [src]="item.logo" alt="currency logo" />
        }
        <span class="name">{{ item.currencyName }}</span>
        <span class="label">{{ item.symbol }}</span>
      </div>
      @if (selectedCurrency()?.id === item.id) {
        <span class="icon icon-check"></span>
      }
    </div>
  }
</div>
